export default __webpack_public_path__ + "static/media/AppIcon.2299de4c.svg";